module.exports = __webpack_public_path__ + "img/pics-icon.df302fa8.svg";